module.exports = __webpack_public_path__ + "img/medal11.bd5a866f.png";